import { Box, TextField } from '@mui/material'
import styles from './customModelDialog.module.scss'

/** The base URL for providers that run on your own endpoint. */
export default function EndpointField({ placeholder, value, error, onChange }) {
  return (
    <Box className={styles.section}>
      <label className={styles.label} htmlFor="custom-model-endpoint">
        Endpoint URL
      </label>
      <TextField
        id="custom-model-endpoint"
        fullWidth
        variant="outlined"
        className={styles.input}
        value={value}
        placeholder={placeholder}
        error={Boolean(error)}
        onChange={(event) => onChange(event.target.value)}
        slotProps={{ htmlInput: { inputMode: 'url', spellCheck: false } }}
      />
      {error ? <span className={`${styles.helper} ${styles.error}`}>{error}</span> : null}
    </Box>
  )
}
